<div class="bg-blue-600 text-white sticky top-0 z-[9999] w-full print:hidden">
    <div class="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2 text-sm font-medium">
        <span>This store is under review. Purchasing is currently disabled.</span>
        <a [href]="dashboardUrl"
           class="whitespace-nowrap rounded px-3 py-1 text-xs font-semibold text-white bg-blue-800 hover:bg-blue-900">
            <span class="underline font-bold">Log in</span> to request changes or approve for launch.
        </a>
    </div>
</div>
